import * as React from "react";
import { Separator } from "@/components/ui/separator";
export default function TermsSummary() {
  return <section id="terms-summary" className="bg-base py-32 md:py-40 relative overflow-hidden">
      <div className="container mx-auto px-4 text-center">
        <h1 className="font-sans font-extrabold text-5xl md:text-6xl lg:text-7xl mb-8 tracking-tight">
          Terms and Conditions
        </h1>
        
        <p className="font-sans text-sm md:text-base font-medium tracking-widest uppercase mb-12 text-muted-fg">
          October 2025
        </p>

        <div className="max-w-3xl mx-auto">
          <p className="text-lg md:text-xl leading-relaxed text-muted-fg">
            Please read these terms carefully before using our services. By accessing or using our website, you agree to be bound by these terms and all applicable laws and regulations. This agreement governs your use of our platform, intellectual property rights, and limitations of liability.
          </p>
        </div>

        <div className="mt-20 flex justify-center">
          <Separator className="h-1 w-24 bg-primary rounded-full" />
        </div>
      </div>
    </section>;
}